// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Components
import Header from 'components/SharedComponents/header';
import Footer from 'components/SharedComponents/footer';
import { MenuOverlay } from 'components/SharedComponents/overlays/menu-overlay';
import { SearchInputOverlay } from 'components/search/search-input-overlay';
import Notification from 'components/SharedComponents/notification/notification';

// Modules
import * as userHelper from 'app-lib/helpers/user-helper';
import * as genericHelper from 'app-lib/helpers/genericHelper';

/**
 * Layout component. This will hold the basic app layout
 */

export class Layout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            displayMenuOverlay: false,
            displaySearchInputOverlay: false
        };
    }

    showMenuOverlay() {
        genericHelper.disableScrolling();
        this.setState({ displayMenuOverlay: true });
    }

    hideMenuOverlay() {
        genericHelper.enableScrolling();
        this.setState({ displayMenuOverlay: false });
    }

    menuOverlay() {
        const menuProps = {
            displayMenuOverlay: this.state.displayMenuOverlay,
            hideMenuOverlay: this.hideMenuOverlay.bind(this),
            myChannelKey: userHelper.getMyChannelKey(this.props.identity)
        };
        return (<MenuOverlay {...menuProps} />);
    }

    showSearchInputOverlay() {
        genericHelper.disableScrolling();
        this.setState({ displaySearchInputOverlay: true });
    }

    hideSearchInputOverlay() {
        genericHelper.enableScrolling();
        this.setState({ displaySearchInputOverlay: false });
    }

    searchInputOverlay() {
        const searchInputProps = {
            displaySearchInputOverlay: this.state.displaySearchInputOverlay && this.props.launchDarkly.search.enableSearch,
            hideSearchInputOverlay: this.hideSearchInputOverlay.bind(this)
        };
        return (<SearchInputOverlay {...searchInputProps} />);
    }

    header() {
        const headerProps = {
            showMenuOverlay: this.showMenuOverlay.bind(this),
            showSearchInputOverlay: this.showSearchInputOverlay.bind(this),
            isSignedIn: this.props.auth.isLoggedIn,
            myChannelKey: userHelper.getMyChannelKey(this.props.identity),
            isOrganizer: this.props.isOrganizer,
            launchDarkly: this.props.launchDarkly
        };
        return (<Header {...headerProps} />);
    }

    render() {
        const {footer, notification} = this.props;
        return (
            <div className="layout">
                {notification.isActive ? <Notification /> : null}
                <section className={'page'}>
                    {this.header()}
                    {this.menuOverlay()}
                    {this.searchInputOverlay()}
                        {
                            this.props.children && React.cloneElement(this.props.children, {
                                auth: this.props.auth,
                                identity: this.props.identity,
                                channel: this.props.channel,
                                launchDarkly: this.props.launchDarkly,
                                isUserLoggedIn: this.props.isUserLoggedIn,
                                isOrganizer: this.props.isOrganizer,
                                myChannelKey: userHelper.getMyChannelKey(this.props.identity),
                                showSearchInputOverlay: this.showSearchInputOverlay.bind(this)
                            })
                        }
                    {footer.isActive ? <Footer /> : null}
                </section>
            </div>
        );
    }
}

Layout.propTypes = {
    children: PropTypes.element.isRequired,
    header: PropTypes.object.isRequired,
    footer: PropTypes.object.isRequired,
    notification: PropTypes.object,
    auth: PropTypes.object,
    identity: PropTypes.object,
    isUserLoggedIn: PropTypes.bool,
    isOrganizer: PropTypes.bool,
    channel: PropTypes.object,
    launchDarkly: PropTypes.object
};

export default connect(
    (state, ownProps) => {
        return (
            {
                header: state.header,
                footer: state.footer,
                notification: state.notification,
                path: ownProps.location.pathname,
                filter: ownProps.location.query.filter
            }
        );
    },
    dispatch => bindActionCreators(Object.assign({}), dispatch)
)(Layout);



// WEBPACK FOOTER //
// ./src/layout.js